import { createClient } from '@supabase/supabase-js';

// Public anon key — είναι OK να υπάρχει στο frontend· η ασφάλεια έρχεται από τα RLS policies.
export const SUPABASE_URL      = 'https://gpkjyoznjowufswwnafh.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdwa2p5b3puam93dWZzd3duYWZoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMyNDM0NTMsImV4cCI6MjA4ODgxOTQ1M30.xPbh4DzL5gssVcz4PWdk1hwm262_1z5wg1U_qsSLB-A';

// Φόρμες επικοινωνίας (Contact + Inquiry modal) -> Edge Function submit-inquiry
export const SUBMIT_INQUIRY_URL = `${SUPABASE_URL}/functions/v1/submit-inquiry`;
// Από google.com/recaptcha/admin -> Site Key (public)
export const RECAPTCHA_SITE_KEY = '6LdNAWUtAAAAAIapp724UA9ASbVDn-QJ0uOTWCno';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
